<template>
  <div class="fm-file-icon" :style="{ '--icon-color': info.color }">
    <img v-if="showThumbnail && item.thumbnail" :src="item.thumbnail" class="fm-thumbnail" :alt="item.name" />
    <div v-else class="fm-icon-wrap">
      <i :class="info.icon" class="fm-icon-glyph"></i>
      <span v-if="info.label" class="fm-ext-badge">{{ info.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useFileIcons } from './useFileIcons.js';

const props = defineProps({
  item: { type: Object, required: true },
  showThumbnail: { type: Boolean, default: true },
});

const { getIconInfo, isImage } = useFileIcons();
const info = computed(() => getIconInfo(props.item));
</script>

<style scoped>
.fm-file-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.fm-icon-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.fm-icon-glyph {
  font-size: 2.8rem;
  color: var(--icon-color);
  line-height: 1;
}
.fm-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.fm-ext-badge {
  font-size: 0.52em;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--icon-color);
  text-transform: uppercase;
  line-height: 1;
}
</style>
